import { Button } from '@/shared/components/ui/button';
import { CardContent, CardFooter } from '@/shared/components/ui/card';
import { useTranslation } from 'react-i18next';
import { Input } from '@/shared/components/ui/input';
import { Link } from 'react-router-dom';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/shared/components/ui/form';
import { useLoginForm } from '@/features/auth-login';
import { AuthCard } from '../../../shared/components/AuthCard';
import { useLogin } from '@/features/auth-login';
import { ErrorText } from '@/shared/components';
import { useWidgetMode } from '@/shared/lib';

type Props = {
  className?: string;
};

const LoginForm = ({ className }: Props) => {
  const { t } = useTranslation();
  const { runLoginProcess, loginError, isLoginLoading } = useLogin();
  const { anchorProps } = useWidgetMode();
  const { form } = useLoginForm();

  return (
    <AuthCard className={className} title={t('authPages.loginForm.title')}>
      <CardContent className="mb-8 p-0">
        <Form {...form}>
          <form
            className="space-y-10"
            noValidate
            onSubmit={form.handleSubmit(runLoginProcess)}>
            <FormField
              control={form.control}
              name="login"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input
                      {...field}
                      type="email"
                      label={t('authPages.loginForm.emailInputPlaceholder')}
                      className="p3"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}></FormField>
            <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input
                      {...field}
                      type="password"
                      label={t('authPages.loginForm.passwordInputPlaceholder')}
                      className="p3"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}></FormField>
            <Button variant={'link'} asChild className="headline5 p-0 mb-16">
              <Link
                target={anchorProps.target}
                rel={anchorProps.rel}
                to="/login/password-recovery">
                {t('authPages.loginForm.forgotPasswordButton')}
              </Link>
            </Button>
            {loginError && <ErrorText size="small">{loginError}</ErrorText>}
            <Button loading={isLoginLoading} type="submit" size="lg">
              {t('authPages.loginForm.loginButton')}
            </Button>
          </form>
        </Form>
      </CardContent>
      <CardFooter className="flex gap-2 items-center justify-center p3 px-0">
        <span className="text-secondary whitespace-nowrap">
          {t('authPages.loginForm.noAccountText')}
        </span>
        <Button variant={'link'} asChild className="p-0">
          <Link target={anchorProps.target} rel={anchorProps.rel} to="/signup">
            {t('authPages.loginForm.linkToSignup')}
          </Link>
        </Button>
      </CardFooter>
    </AuthCard>
  );
};

export { LoginForm };
